import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { ThemeProvider } from "@/context/ThemeContext";
import AppShell from "@/components/shell/AppShell";
import { ONGLETS } from "@/components/shell/nav";
import Connexion from "@/pages/Connexion";
import Invitation from "@/pages/Invitation";
import Reinitialisation from "@/pages/Reinitialisation";
import Accueil from "@/pages/Accueil";
import Fiches from "@/pages/Fiches";
import FicheDetail from "@/pages/FicheDetail";
import SalleVisio from "@/pages/SalleVisio";
import Bientot from "@/pages/Bientot";
import MaListe from "@/pages/MaListe";
import Prospection from "@/pages/Prospection";
import Parametres from "@/pages/Parametres";
import ThemeEditeur from "@/pages/ThemeEditeur";
import Pipeline from "@/pages/Pipeline";
import ContactPage from "@/pages/ContactPage";
import ModeFocus from "@/pages/ModeFocus";
import Agenda from "@/pages/Agenda";
import Depot from "@/pages/Depot";
import Satisfaction from "@/pages/Satisfaction";
import Devis from "@/pages/Devis";
import ReglesAutomatisation from "@/pages/parametres/ReglesAutomatisation";
import FocusConfirmateur from "@/pages/FocusConfirmateur";
import TableauxDeBord from "@/pages/TableauxDeBord";
import MurEquipe from "@/pages/MurEquipe";
import MesOutils from "@/pages/MesOutils";
import OutilEditeur from "@/pages/OutilEditeur";
import PartageLecture from "@/pages/PartageLecture";
import MaquetteCRM from "@/pages/MaquetteCRM";

const Chargement = () => (
  <div className="min-h-screen flex items-center justify-center" data-testid="app-loading">
    <span className="w-10 h-10 at-pill animate-pulse" style={{ background: "var(--micro)" }} />
  </div>
);

const Protege = ({ children }) => {
  const { user } = useAuth();
  const location = useLocation();
  if (user === null) return <Chargement />;
  if (!user) return <Navigate to="/connexion" replace state={{ depuis: location.pathname }} />;
  return children;
};

const Onglet = ({ code, children }) => {
  const { user } = useAuth();
  return user.navigation.onglets.includes(code) ? children : <Navigate to="/" replace />;
};

const PublicSeul = ({ children }) => {
  const { user } = useAuth();
  if (user === null) return <Chargement />;
  return user ? <Navigate to="/" replace /> : children;
};

const BIENTOT = {
};

export default function App() {
  return (
    <AuthProvider>
      <ThemeProvider>
      <TooltipProvider delayDuration={200}>
        <BrowserRouter>
          <Routes>
            <Route path="/connexion" element={<PublicSeul><Connexion /></PublicSeul>} />
            <Route path="/depot/:token" element={<Depot />} />
            <Route path="/satisfaction/:token" element={<Satisfaction />} />
            <Route path="/partage/:token" element={<PartageLecture />} />
            <Route path="/invitation/:token" element={<Invitation />} />
            <Route path="/reinitialisation/:token" element={<Reinitialisation />} />
            <Route path="/mur" element={<Protege><MurEquipe /></Protege>} />
            <Route index element={<Protege><MaquetteCRM /></Protege>} />
            <Route element={<Protege><AppShell /></Protege>}>
              <Route path="accueil-donnees" element={<Accueil />} />
              <Route path="fiches" element={<Onglet code="fiches"><Fiches /></Onglet>} />
              <Route path="fiches/:id" element={<Onglet code="fiches"><FicheDetail /></Onglet>} />
              <Route path="visio/:id" element={<SalleVisio />} />
              <Route path="outils" element={<Onglet code="outils"><MesOutils /></Onglet>} />
              <Route path="outils/:id" element={<Onglet code="outils"><OutilEditeur /></Onglet>} />
              <Route path="tableaux" element={<Onglet code="tableaux"><TableauxDeBord /></Onglet>} />
              <Route path="pipeline" element={<Onglet code="pipeline"><Pipeline /></Onglet>} />
              <Route path="appels" element={<Onglet code="appels"><MaListe /></Onglet>} />
              <Route path="focus" element={<Onglet code="appels"><ModeFocus /></Onglet>} />
              <Route path="focus-confirmation" element={<FocusConfirmateur />} />
              <Route path="devis" element={<Onglet code="devis"><Devis /></Onglet>} />
              <Route path="automatisations" element={<Onglet code="automatisations"><ReglesAutomatisation /></Onglet>} />
              <Route path="validations" element={<Bientot titre="Validations" lot="à venir" texte="L'IA propose, vous décidez : cet écran de la maquette sera construit à son tour." />} />
              <Route path="agenda" element={<Onglet code="agenda"><Agenda /></Onglet>} />
              <Route path="fichiers-prospection" element={<Onglet code="fichiers_prospection"><Prospection /></Onglet>} />
              <Route path="contacts/:id" element={<ContactPage />} />
              {Object.entries(BIENTOT).map(([code, b]) => (
                <Route key={code} path={ONGLETS[code].path.slice(1)} element={<Onglet code={code}><Bientot titre={ONGLETS[code].label} {...b} /></Onglet>} />
              ))}
              <Route path="parametres" element={<Navigate to="/parametres/compte" replace />} />
              <Route path="parametres/themes/:themeId" element={<ThemeEditeur />} />
              <Route path="parametres/:section" element={<Parametres />} />
              <Route path="*" element={<Navigate to="/" replace />} />
            </Route>
          </Routes>
        </BrowserRouter>
      </TooltipProvider>
      <Toaster position="top-center" toastOptions={{ className: "at-popover", style: { fontFamily: "var(--font)" } }} />
      </ThemeProvider>
    </AuthProvider>
  );
}
